import { render } from "./CreateHouse.vue?vue&type=template&id=7cad6653"
import script from "./CreateHouse.vue?vue&type=script&lang=js"
export * from "./CreateHouse.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/Verent_PactoAdmin_FE_UI/Verent_PactoAdmin_FE_UI/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__